// extracted by css-extract-rspack-plugin
export default {"toggleContainer":"hierarchy-toggle-module__toggleContainer__PGEFt","betaLink":"hierarchy-toggle-module__betaLink__t3b9n","betaLabel":"hierarchy-toggle-module__betaLabel__QQvIT"};